import { Stack } from '@mui/material'
import BackgroundGoogleMap from "../../../../components/images/RightGoogleMap.png"


interface RightGoogleMapProps {
  style?: {
    width: {
      xs: string | number
    }
  }
}

const RightGoogleMap = ({ style }: RightGoogleMapProps) => {
  return (
    <Stack
      flexGrow="1"
      sx={{
        backgroundImage: `url(${BackgroundGoogleMap})`, backgroundRepeat: "no-repeat", backgroundSize: "cover",
        width: style?.width.xs,
      }}
    />
  )
}

export default RightGoogleMap